import { defineStore } from 'pinia'

import { getCurrentUser, getInvitationStatus, getNetworkByUser } from '~/entities/user/user/api/users'
import type { IUser, NetworkUser } from '~/entities/user/user/interfaces/user'

import { deleteUserFromNetwork } from '~/features-swym/network-activity/api/network-activities'

import type { SUBJECT_6W_URI } from '~/features-shared/libs/interfaces/entity'

export const useNetworkStore = defineStore('network-activities', () => {
  //  STATE
  const threads = ref<Map<string, NetworkUser & { subject_uri: SUBJECT_6W_URI, title: string }>>(new Map())
  // #endregion

  // ACTIONS
  const fetchList = async () => {
    const currentUser = (await getCurrentUser()).result

    if (!currentUser.hash_key)
      return

    const networkUsers = (await getNetworkByUser(currentUser?.hash_key)).result.users
    networkUsers.forEach((i) => {
      threads.value.set(`${i.hash_key}`, Object.assign({ subject_uri: `${i.hash_key}`, title: `${i.first_name} ${i.last_name}`, login: i.login, external: Number.parseInt(i.tenant_user_status || '') }, i))
    })
  }
  const deleteConnection = async (hash_key: string) => {
    await deleteUserFromNetwork(hash_key)
    threads.value.delete(hash_key)
  }
  const getStatusInvitation = async (hashKey?: string, uid?: string) => {
    return (await getInvitationStatus(hashKey, uid)).result
  }
  const addNewThread = (hash_key: string, user: IUser) => {
    threads.value.set(hash_key, Object.assign({
      subject_uri: `${user.hash_key}`,
      title: `${user.first_name} ${user.last_name}`,
      login: user.login,
      external: Number.parseInt(user.tenant_user_status as string) as 0 | 1,
    }, user))
    // eslint-disable-next-line max-len
    const threadSorted = new Map<string, NetworkUser & { subject_uri: SUBJECT_6W_URI, title: string }>([...threads.value.entries()].sort((a, b) => {
      return a[1].last_name.toLowerCase()
        .localeCompare(b[1].last_name.toLowerCase())
    }))
    threads.value = new Map(threadSorted)
  }
  return {
    fetchList,
    deleteConnection,
    getStatusInvitation,
    threads,
    addNewThread,
  }
})
